import { ArrowRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { AttachmentsBlock } from "./Allegati";
import { InstallatiDaNoi } from "./InstallatiDaNoi";
import { splitParagraphs } from "../lib/products";
import { scrollToSection } from "../lib/scroll";

export const OfficinaSheet = ({ c, onClose }) => (
    <Dialog open={!!c} onOpenChange={onClose}>
        <DialogContent
            data-lenis-prevent
            className="max-h-[90vh] max-w-3xl overflow-y-auto rounded-3xl border-0 p-0"
            data-testid="officina-sheet-modal"
        >
            {c && (
                <div className="grid md:grid-cols-5">
                    <div
                        className={`flex items-center justify-center md:col-span-2 ${
                            c.photo ? "" : "bg-[#0B1F3A] p-8"
                        }`}
                    >
                        <img
                            src={c.img}
                            alt={c.title}
                            className={c.photo ? "h-56 w-full object-cover md:h-full" : "max-h-64 w-auto object-contain drop-shadow-[0_16px_24px_rgba(0,0,0,0.45)]"}
                        />
                    </div>
                    <div className="p-7 md:col-span-3 sm:p-9">
                        <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#E30613]">
                            Divisione Autoriparatore{c.brand ? ` · ${c.brand}` : ""}
                        </span>
                        <DialogTitle className="font-display mt-2 text-3xl font-extrabold tracking-tight text-[#0B1F3A]">
                            {c.title}
                        </DialogTitle>
                        <DialogDescription className="mt-3 text-sm leading-relaxed text-[#475569]">
                            {c.desc}
                        </DialogDescription>
                        {c.description && (
                            <div className="mt-3 space-y-2" data-testid="officina-sheet-description">
                                {splitParagraphs(c.description).map((par) => (
                                    <p key={par.slice(0, 40)} className="text-sm leading-relaxed text-[#334155]">{par}</p>
                                ))}
                            </div>
                        )}
                        <AttachmentsBlock productKey={c.key} />
                        <InstallatiDaNoi productKey={c.key} />
                        <button
                            data-testid="officina-sheet-quote-button"
                            onClick={() => {
                                onClose();
                                scrollToSection("contatti");
                            }}
                            className="mt-7 inline-flex items-center gap-2 rounded-full bg-[#E30613] px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-[#C20410]"
                        >
                            Richiedi informazioni
                            <ArrowRight className="h-4 w-4" />
                        </button>
                    </div>
                </div>
            )}
        </DialogContent>
    </Dialog>
);
